import { render, staticRenderFns } from "./FixationItemHolder.vue?vue&type=template&id=231f9c91&scoped=true&"
import script from "./FixationItemHolder.vue?vue&type=script&lang=js&"
export * from "./FixationItemHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f9c91",
  null
  
)

export default component.exports